export const titleToPath = (title: string, parentPath?: string): string => {
    const path = title.toLowerCase().replace(/[^a-zA-Z0-9]/g, '-');
    return parentPath ? `${parentPath}/${path}` : path;
};
